import type { HandState } from '@/engine/types';

/**
 * Canonical "what should we show as the pot number" calculation.
 * Prefers the engine's resolved side-pot sum; falls back to total
 * per-player hand contributions while the street is still resolving.
 */
export function computePot(state: HandState): number {
  return (
    state.betting.pots.reduce((sum, p) => sum + p.amount, 0) ||
    state.players.reduce((sum, p) => sum + p.handContribution, 0)
  );
}
